module.exports = __webpack_public_path__ + "static/media/zalando-logo.ca8d8ea9.svg";